module.exports = __webpack_public_path__ + "media/application/images/royston-logo-aa719116f94c0dd371e6f8e9b8b10b4b.png";